import { differenceInHours } from 'date-fns';

export function generateFullPropertyInfoString({
  price,
  bedrooms,
  bathrooms,
}: {
  price: number | null;
  bedrooms: number | null;
  bathrooms: number | null;
}) {
  const bedroomsExist = bedrooms && bedrooms > 0;
  const bathroomsExist = bathrooms && bathrooms > 0;

  const priceString = price
    ? `${price.toLocaleString('en', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      })}${bedroomsExist || bathroomsExist ? ';' : ''} `
    : '';
  const bedroomString = bedroomsExist
    ? `${bedrooms} bed${bathroomsExist ? ',' : ''} `
    : '';
  const bathroomString = bathroomsExist ? `${bathrooms} bath` : '';

  return `${priceString}${bedroomString}${bathroomString}`.trim();
}

export function generateBedBathString({
  bedrooms,
  bathrooms,
}: {
  bedrooms: number | null;
  bathrooms: number | null;
}) {
  const bedroomsExist = bedrooms && bedrooms > 0;
  const bathroomsExist = bathrooms && bathrooms > 0;

  const bedroomString = bedroomsExist
    ? `${bedrooms} bed${bathroomsExist ? ',' : ''} `
    : '';
  const bathroomString = bathroomsExist ? `${bathrooms} bath` : '';

  return `${bedroomString}${bathroomString}`.trim();
}

/**
 * Returns true if the given date is within the last 24 hours
 * @param date date to check
 * @returns boolean
 */
export function isRecentDate(date: string | null) {
  const currentDate = new Date();
  return !!date && differenceInHours(currentDate, date) < 24;
}
